<template>
  <div class="app">
    <VueQueryDevtools />
    <LazyFeaturesTourHelpCenter v-if="!isExcluded && !isMobile && !isTourCompleted" />
    <NuxtLayout>
      <NuxtPage />
      <DynamicPopup />
      <DynamicMobilePanel />
    </NuxtLayout>
    <UISnackBanner />
    <FeaturesNetworkChecker />
    <UISupportPanel v-if="!isExcluded" />
  </div>
</template>
<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import useUIStore from '~/store/ui'
import { TOURS_CODES } from '~/constants'

const { checkVersion } = useVersionCheck()

const EXCLUDED_ROUTES_NAME = ['properties', 'properties-id']

const route = useRoute()

const routeName = computed(() => {
  return route.name
})

const uiStore = useUIStore()

const { isMobile } = useAppBreakpoints()

const isExcluded = computed(() => {
  return EXCLUDED_ROUTES_NAME.includes(routeName.value?.toString() || '')
})

const isTourCompleted = computed(() => {
  return uiStore.getIsTourCompleted(TOURS_CODES.HELP_CENTER)
})

onMounted(() => checkVersion())
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.page-enter-active,
.page-leave-active,
.layout-enter-active,
.layout-leave-active {
  transition: $base-transition opacity;
}

.page-enter-from,
.page-leave-to,
.layout-enter-from,
.layout-leave-to {
  opacity: 0;
}
</style>
